import api from "../../../../api/billManagementApi/cloud-invoicing/index";
export const moduleId = 'cloud-invoicing';
export const state = {
    invoicingDetail: false,
    drawId:'',
    productList: [],//税收分类
    abIdForm:{},//账套详情
    terminalId:'',//终端id
    orgList:[]
}
export const actions = {
    // onCreate({ dispatch, state, commit }, { to, from }) {
    //     console.log(1111)
    //     dispatch("initView")
    // },
    // onResume({ dispatch, state, commit, getters }, { to, from }) {
    //     console.log(1111)
    // },
    // initView({ commit, state, dispatch }) {
    //     console.log(1111)
    //     dispatch("getTaxList")

    // },
    async getTaxList({ state, commit, dispatch }) {
        let res = await api.TaxAllList()
        if (res.code === 0) {
            let list = res.data.splice(0, 5);
            commit("setProductList", list)
        }
    }
}

export const mutations = {
    setInvoicingDetail(state, data) {
        state.invoicingDetail = data
    },
    setProductList(state, data) {
        state.productList = data
    },
    setFindByAbIdForm(state,data){
        state.abIdForm = data
    },
    setDrawId(state,data){
        state.drawId = data
    },
    setOrgList(state,data){
        state.orgList = data
    }
} 


// WEBPACK FOOTER //
// ./src/store/modules/bill-management/cloud-invoicing/index.js